import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ec3a4c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_3 = {
  key: 1,
  class: "router-link-wrapper"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Already have account? Login here")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_terms = _resolveComponent("terms")!
  const _component_app_alert = _resolveComponent("app-alert")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.nextStep,
      as: "el-form",
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(({errors}) => [
        _createVNode(_component_app_input, {
          modelValue: _ctx.passwordValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwordValue) = $event)),
          clearable: "",
          "show-password": "",
          name: "password",
          label: "Password",
          placeholder: "Enter your password"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_app_button, {
          disabled: !_ctx.passwordValue || !!errors.password,
          type: "primary",
          "native-type": "submit",
          class: "w-100 el-button-lg",
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 2
        }, 1032, ["disabled"]),
        _createVNode(_component_terms),
        (_ctx.errorKey)
          ? (_openBlock(), _createBlock(_component_app_alert, {
              key: 0,
              title: _ctx.errorKey,
              closable: false,
              type: "error"
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (_ctx.errorKey)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "router-link",
                to: "/login"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"]),
    (_ctx.createInProgress)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: "Creating account..."
        }))
      : _createCommentVNode("", true)
  ]))
}